import React from 'react';

import BirthdayMessage from './BirthdayMessage';
import ChairLiftingMessage from './ChairLiftingMessage';
import HtmlMessage from './HtmlMessage';
import MemorialMessage from './MemorialMessage';
import PlainTextMessage from './PlainTextMessage';
import ShabbatPlanningMessage from './ShabbatPlanningMessage';
import { isRichTextMessage } from '../../utils/html';

export default function MessageContent({ message, metadata }) {
  switch (message?.type) {
    case 'message':
      return isRichTextMessage(message.crfd1_content) ? (
        <HtmlMessage content={message.crfd1_content} />
      ) : (
        <PlainTextMessage content={message.crfd1_content} />
      );
    case 'birthday':
      return <BirthdayMessage message={message} />;
    case 'chair-lifting':
      return <ChairLiftingMessage message={message} />;
    case 'shabbat-planning':
      return <ShabbatPlanningMessage message={message} />;
    case 'zl':
      return <MemorialMessage message={message} metadata={metadata} />;
    case 'loading':
      return <span className="panel-placeholder">טוען הודעות...</span>;
    default:
      return 'אין מידע להצגה';
  }
}
